import {confirmAndDeleteFood, useFoodForms} from "@client/features/foods";
import * as search from "@client/features/search";
import * as forms from "@client/forms";
import * as router from "@client/router";
import {server} from "@reactivated";
import React from "react";

export const UpdateFood = router.UpdateFood.withHooks((props) => {
    return useFoodForms({initial: props.resolved.update_food});
})
    .withTab(
        {
            name: "macros",
            icon: "bullseye",
            title: "Macros",
            hasErrors: (props) => props.basicLayout.hasErrors,
        },
        (props) => <>{props.basicLayout.component}</>,
    )
    .withTab(
        {
            name: "advanced",
            icon: "list",
            title: "Advanced",
            hasErrors: (props) => props.advancedLayout.hasErrors,
        },
        (props) => <>{props.advancedLayout.component}</>,
    )
    .withActions((props) => [
        {
            icon: "remove",
            title: "",
            onClick: () =>
                props.dispatch(confirmAndDeleteFood(props.resolved.update_food)),
        },
        {
            icon: "save",
            title: "Save",
            onClick: async () => {
                const response = await forms.submitForm(props.form, (data) =>
                    server.journal.nutrition.update_food({
                        ...data,
                        food_id: props.resolved.update_food.id,
                    }),
                );
                if (response?.type === "success") {
                    void props.dispatch(search.loadSearch({reset: true}));
                    props.notify("Your food was updated");
                    void router.push("food_list.index", {});
                }
            },
        },
    ])
    .withOptions(() => ({
        title: "Update Food",
        back: "My Foods",
        scene: {kind: "SIMPLE"},
    }));
